
import React from "react";
import { Card, Form, Button, Divider, message, Row, Col,Modal } from 'antd';
import PropTypes from 'prop-types';
import NHFetch from '../../../utils/NHFetch';
import NHInputRender from '../../common/NHInputPicker/render';
import moment from 'moment';
import { getLoginUser } from "../../../utils/NHCore";
import { hasAuth } from "../../../utils/NHCore";
import { NHModal, NHConfirm } from '../../common/NHModal';
import styles from '../index.css';

const basicUrl = '/yxxc/';

class Common extends React.Component {
    constructor(props) {
        super()
        this.state = {
            hjblztData: {}, //环节办理状态信息
            hjywxData: [], //环节业务项信息
            editable: true, //是否可编辑
            loading: false, //按钮转圈等待
            previewVisible: false,
            dmkmcList:{},
            autoHjywxData:props.hjywxData ? props.hjywxData :[],  //自动办理环节业务项信息
            autoLchjData:props.lchjData ? props.lchjData : {},   //自动办理流程环节信息
        };
        
    }

    componentDidMount(){
        const { location } = this.props;
        const { search } = location;
        let params = decodeURIComponent(search);
        this.initAutoHandleData(params);
    }

    componentWillReceiveProps(nextProps) {
        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            if (hjblztData) {
                let editable = hjblztData.blzt == '1' ? false : true;
                this.setState({ hjblztData: hjblztData, editable: editable });
            } else {
                this.setState({ hjblztData: hjblztData, editable: true });
            }
        }
        if (this.props.location.search !== nextProps.location.search){
            let params = decodeURIComponent(nextProps.location.search);
            this.initAutoHandleData(params);
        }
    }

    //初始化自动办理环节数据
    initAutoHandleData =(params)=>{
        const { lchjData={} } = this.props;
        if (Object.keys(lchjData).length == 0){
            NHFetch(basicUrl+'initAutoHandleData'+params,'GET').then(res =>{
                if (res && res.data){
                    this.setState({
                        autoLchjData:res.data['lchjData'] ? res.data['lchjData'] : {},
                        autoHjywxData: res.data['hjywxData'] ? res.data['hjywxData'] : []
                    })
                } else {
                    message.error("获取自动办理环节初始化数据失败")
                }
            })
        }
    }
    //确认办理
    handleSubmit = () => {

        const { xsid } = this.props.studentData;

        if (!xsid) {
            message.error("环节办理失败,请先查询学生信息！");
            return;
        }

        const form = this.props.form;

        //校验
        form.validateFields((err, formData) => {

            if (err) {
                return;
            } 
            
            //处理保存到数据库中的数据 
            Object.keys(formData).forEach(function(key){ 
                if(formData[key]!=null && formData[key]!=undefined){
                      if(formData[key].constructor.name == 'Array'){ 
                        if (typeof formData[key] === 'object') { 
                            let isFileUpload = false;
                            let array = [];
                            for (let item of formData[key]) {
                                if (item.hasOwnProperty('uuid') && item['uuid']) {
                                    isFileUpload = true;
                                    array.push(item['uuid']) 
                                }
                            }
                            if (isFileUpload) {
                                formData[key]= array.join(',');
                            }else{
                                formData[key] =  formData[key].join(',');
                            }
                        }else{ 
                            formData[key] =  formData[key].join(',');
                        } 
                    }   
                 } 
            });
            const { pkid, hjdm } = this.state.hjblztData;
            const { xsid } = this.props.studentData;
            let userId = getLoginUser() ? getLoginUser().userId : '';
            let params = { xsid: xsid, lchjid: pkid, formData: formData, yhbh: userId, hjdm: hjdm };
            this.setState({ loading: true });
            NHFetch(basicUrl + 'saveCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            message.success('环节办理成功！');
                            //办理完成回调
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('submit');
                            }
                        } else if (res.data === 2) {
                            // 武汉铁路
                            message.warn("学生未缴费");
                        } else if (res.data === 3) {
                            // 武汉铁路
                            message.warn("缴费数据同步成功，该生未达到系统设置的最低缴费金额，无法自动办理缴费环节!");
                        } else if (res.data === 4) {
                            // 武汉铁路
                            message.warn("同步学生缴费信息失败");
                        } else {
                            message.error('环节办理失败，请重试！');
                        }
                        this.setState({ loading: false });
                    }
                    this.setState({ loading: false });
                }).catch((ress) => {
                    this.setState({ loading: false });
                })

        });
    }

    //取消办理
    handleCancel = () => {
        const { pkid } = this.state.hjblztData;
        const { xsid } = this.props.studentData;
        let userId = getLoginUser() ? getLoginUser().userId : '';   
        let params = { xsid: xsid,  yhbh: userId, lchjid: pkid };
        NHConfirm("是否确定取消办理？", () => {
            this.setState({ loading: true });
            NHFetch(basicUrl + 'cancelCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            message.success('环节办理取消成功！');
                            //取消办理完成回调
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('cancel');
                            }
                        } else {
                            message.error('环节办理取消失败，请重试！');
                        }
                    }
                    this.setState({ loading: false });
                }).catch((ress) => {
                    this.setState({ loading: false });
                })
        }, "warn");

    }

    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
    }

    //上一步
    handleLast = () => {
        let onLast = this.props.onLast;
        if (onLast) {
            onLast();
        }
    }

    //下一步
    handleNext = () => {
        let onNext = this.props.onNext;
        if (onNext) {
            onNext();
        }
    }

    //获取下拉列表value对应的名称
    getDmkMc = (dmbz, zdbz) => {
        NHFetch("/proData/selectDataList", "GET", { sign: dmbz })
            .then(res => {
                if (res) {
                    if (res.data) {
                        let dmkmcList = this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        this.setState({
                            dmkmcList: dmkmcList
                        })
                    }
                }
            });
    }

       //获取联级下拉列表value对应的名称
       getCascaderDmkMc = (level,sign, cascaderValue,zdbz) => { 
        NHFetch("/proData/selectCascaderList", "GET", { level:level,sign: sign ,cascaderValue:cascaderValue})
            .then(res => {  
                if (res) {
                    if (res.data) {
                        let dmkmcList = this.state.dmkmcList;
                        dmkmcList[level+zdbz] = res.data; 
                        this.setState({
                            dmkmcList: dmkmcList
                        })
                    }
                }
            });
    }
      
     // 点击文件链接或预览图标时的回调
     handlePreview = (fjmc, fjid) => {

        if (fjmc==="isImage") {
            this.showPreview(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        } else {
            window.open(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        }
    };

    //打开图片弹窗
    showPreview = (url) => {
        this.setState({
            previewImage: url,
            previewVisible: true
        });
    }
    // 关闭图片弹窗
    closeModal = () => this.setState({ previewVisible: false });
    // 文件展示
    fileLists = (fileLists) => {
        {
            let items=[];
            for(let key in fileLists){
                let fileList = fileLists[key].split(";");
                items.push (
                    <span>
                        <a onClick={() => {
                        this.handlePreview("file",fileList[0]);
                        }}>{fileList[1]} </a> 
                    </span>
                )
            }
        return items;
        }
    };
    //图片展示
    imageLists = (imageLists) =>{
        {
            let items=[];
            for(let key in imageLists){
                let imageList = imageLists[key].split(";");
                items.push (
                    <span>
                    <img style={{height:"86px" ,width:"86px"}} src={"anonymity/docrepo/download/file?attachmentId=" + imageList}
                     onClick={() => {
                        this.handlePreview("isImage",imageList[0]);
                        }}/>
                    </span>
                )
            }
            return items;
        }
    }

    //自动办理
    onAutoHandle =() =>{
        const { autoHjywxData,autoLchjData } = this.state;
        if (autoHjywxData && autoHjywxData.length >0){
            message.error("该环节存在业务项，不能使用自动办理")
        } else {
            this.props.onAutoHandle(autoLchjData);
        }
    }

    render() {
        const { form, hjywxData, hjblztData, lchjData = {}, hasLast, hasNext, } = this.props;
        const { editable, loading,previewVisible,previewImage,autoLchjData,autoHjywxData } = this.state;
        const { sfdybdd = '0' } = lchjData; //是否打印报到单
        console.log(autoLchjData)
        let formItems = [];
        let formItemLayout = { //表单项布局
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 8 },
            }
        }

        if (hjywxData && hjywxData.length > 0) {

            for (let key in hjywxData) {
                let hjywx = hjywxData[key];
                let kjcsjson = JSON.parse(hjywx.kjcs);
                let ywxz = hjywx.ywxz;
                let zdbz = hjywx.zdbz;
                let formItem = "";
                if (editable) {
                    formItem = (
                        <NHInputRender 
                            key={hjywx.pkid}
                            id={hjywx.pkid}
                            label={hjywx.zdmc}
                            defaultValue={hjywx.mrz}
                            value={kjcsjson.validationValueType === 'array' ? (ywxz ? ywxz .split(",") : []) : ywxz}
                            required={hjywx.sfbt == '1' ? true : false}
                            form={form}
                            feature={hjywx.kjcs}
                            formItemLayout={formItemLayout} />
                    );
                } else {
                    if(ywxz&&(kjcsjson.type === 'datepicker'||kjcsjson.type === 'datetimepicker'||kjcsjson.type === 'timepicker'||kjcsjson.type === 'monthpicker'||kjcsjson.type === 'rangepicker')){    //日期值展示阶段，从moment转为文字 
                        ywxz = moment(ywxz).format(kjcsjson.format);   
                    }
                    if (kjcsjson.type === "select" ) {
                        if (kjcsjson.dataTag && !this.state.dmkmcList[zdbz]) {
                            this.getDmkMc(kjcsjson.dataTag, zdbz);
                        }
                        let list = this.state.dmkmcList[zdbz];
                        list && list.map(item => {
                            if (item.VALUE === ywxz) {
                                ywxz = item.LABEL;
                            }
                        })
                    }else if (kjcsjson.type === "multiselect") { 
                        if (kjcsjson.dataTag && !this.state.dmkmcList[zdbz]) {
                            this.getDmkMc(kjcsjson.dataTag, zdbz);
                        }
                        let list = this.state.dmkmcList[zdbz]; 
                        if(ywxz){
                            let multiselect=ywxz.split(",");    
                            let multiselectList=[];
                            for(let i in multiselect){
                                list && list.map(item => {
                                    if (item.VALUE === multiselect[i]) {
                                        multiselectList.push(item.LABEL);
                                    }
                                })
                            }
                            ywxz=multiselectList.join(",");
                     }
                    }else if (kjcsjson.type === "nhcascader"&& ywxz ) {    
                            let nhcascaderList=ywxz.split(",");    
                            let nhcascaderLists=[];    
                            for(let i in nhcascaderList){  
                                let level=i;
                                let c=i;
                                let d=i;
                                let a=++level;
                                let b=--d;
                                let flag = false;
                                if (kjcsjson.dataTag && !this.state.dmkmcList[a+zdbz] ) {
                                    if(i == "0"){
                                        this.getCascaderDmkMc(a,kjcsjson.dataTag,'',zdbz) 
                                    }
                                    else{
                                        this.getCascaderDmkMc(a, kjcsjson.dataTag,nhcascaderList[b],zdbz) 
                                    } 
                                }
                                    
                                

                                    let list=this.state.dmkmcList[level+++zdbz];

                                    // 第一次循环，判断下拉选中的值是否在dmkmcList，如果不在，还需要重新请求getCascaderDmkMc接口
                                    list && list.map(item => {   
                                        if (item.value === nhcascaderList[c]) { 
                                            flag = true
                                        }
                                    }) 
                                    if(!flag){
                                        // this.changeIsReload(nhcascaderList[b]);
                                        if(i == "0"){
                                            this.getCascaderDmkMc(a,kjcsjson.dataTag,'',zdbz) 
                                        }
                                        else{
                                            this.getCascaderDmkMc(a, kjcsjson.dataTag,nhcascaderList[b],zdbz) 
                                        } 
                                    }

                                    list && list.map(item => {   
                                        if (item.value === nhcascaderList[c]) { 
                                            nhcascaderLists.push(item.label);
                                        }
                                    }) 
                            }
                            ywxz=nhcascaderLists.join("/"); 
                     }else if (kjcsjson.type === "switch"&& ywxz ) {
                        ywxz = (ywxz === "true") ? kjcsjson.checkedText : kjcsjson.uncheckedText;
                    } else if (kjcsjson.type === "radio"&& ywxz ) {
                        kjcsjson.options && kjcsjson.options.map((item, key) => {
                            if (item.value === ywxz) {
                                ywxz = item.label;
                            }
                        })
                    }else if(kjcsjson.fileType === "file" && ywxz ){  
                        let fileLists=ywxz.split(",");   
                        ywxz=(
                            this.fileLists( fileLists)  
                        )
                    }else if(kjcsjson.fileType === "image" && ywxz){ 
                       
                        let imageLists = typeof ywxz == 'string' ? ywxz.split(",") : ywxz; 
                        if (typeof ywxz === 'object') { 
                            let array = [];
                            for (let item of ywxz) {
                                if (item.hasOwnProperty('uuid') && item['uuid']) {
                                    array.push(item['uuid']) 
                                }
                            }
                            imageLists= array
                        } 
                        ywxz=(
                            this.imageLists(imageLists)  
                        )  
                    }


                    formItem = 
                    <Row className={styles.personal}>
                        <Col xl={7} lg={9} md={12} sm={24} xs={24}>
                            <div><span style={{marginLeft:'30px'}}>{hjywx.zdmc}</span>：<span >{ywxz}</span></div>
                        </Col>
                    </Row>
                    
                }
                formItems.push(formItem);
            }

        } else {
            let formItem = (<span>暂无需要填写的业务项信息</span>);
            formItems.push(formItem);
        }

        return (
            <div>
                <Card type="inner" title={hjblztData && hjblztData.hjmc ? `${hjblztData.hjmc}业务信息` : '业务信息'}>
                    <Form>
                        {formItems}
                    </Form>
                    <Modal
                        visible={previewVisible}
                        footer={null}
                        onCancel={this.closeModal}
                    >
                        <img
                            alt="example"
                            style={{ width: '100%' }}
                            src={previewImage}
                        />
                    </Modal>
                </Card>
                <Divider style={{ margin: '40px 0 24px' }} />
                {
                    editable ?
                        (hasAuth('zhxg_yxgl_yxxc:submit') ? <Button type="primary" onClick={this.handleSubmit} loading={loading}>确认办理</Button> : null)
                        : (hasAuth('zhxg_yxgl_yxxc:cancel') ? <Button type="primary" onClick={this.handleCancel} loading={loading}>取消办理</Button> : null)
                }
                {
                    sfdybdd == '1' ? <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button> : null
                }
                { autoLchjData.hjlx == '2' && !(autoHjywxData &&autoHjywxData.length > 0) ?
                    (hasAuth('zhxg_yxgl_yxxc:autoHandle') ? <Button type="primary" ghost style={{marginLeft: 10}} onClick={this.onAutoHandle}>自动办理</Button>:null)
                    :
                    null
                }
                {
                    hasLast ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button>
                        : null
                }
                {
                    hasNext ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button>
                        : null
                }
            </div>
        )
    }
}

const common = Form.create()(Common);

Common.propTypes = {
    studentData: PropTypes.object, //学生信息
    hjblztData: PropTypes.object, //环节办理状态数据
    hjywxData: PropTypes.array, //环节业务项数据
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool, //是否有上一个环节
    hasNext: PropTypes.bool, //是否有下一个环节
    onLast: PropTypes.func,//上一步操作回调
    onNext: PropTypes.func, //下一步操作回调
    onFinish: PropTypes.func, //环节办理完成回调
    onPrint: PropTypes.func, //打印报到单
    onAutoHandle: PropTypes.func, //自动办理点击回调
}
export default common


// WEBPACK FOOTER //
// ./components/yxxc/steps/common.js